<template>
	<div >
		<!-- <div class="section-header">
			<md-icon class="edit-icon" style="font-size: 16px !important;">
				{{ first_type_icon }}
			</md-icon>
			{{ first_type_sction }}
		</div> -->
		<virtual-list
			:size="100"
			:remain="remain"
			:start="0"
			id="tab-scroll-area"
			class="tab-container"
			:variable="false"
		>
			<Tab
				v-for="tab in tabs"
				:body="tab"
				:key="tab.id"
				:style="{ height: 100 + 'px' }"
			/>
		</virtual-list>
		<!-- <transition-group name="flip">
			<Tab
				v-for="tab in tabs"
				:body="tab"
				:key="tab.id"
			/>
		</transition-group>
		<div class="section-header" v-show="show_second">
			<md-icon class="edit-icon" style="font-size: 16px !important;">
				{{ second_type_icon }}
			</md-icon>
			{{ second_type_sction }}
		</div>
		<transition-group name="flip" v-show="show_second">
			<Tab
				v-for="tab in second_tabs"
				:body="tab"
				:key="tab.id"
			/>
		</transition-group> -->
		<!-- <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading"></infinite-loading> -->
	</div>
</template>
<script>
import Tab from './Tab.vue'
import virtualList from 'vue-virtual-scroll-list'
export default {
	name: 'TabsContainer',
	data() {
		return {
			remain: 9
		}
	},
	computed: {
		tabs () {
			// return this.$store.getters['tabs/data']
			return this.$store.getters['tabs/tabs']
		},
		second_tabs () {
			// return this.$store.getters['tabs/data']
			return this.$store.getters['tabs/second_tabs']
		},
		has_more () {
			return this.$store.getters['tabs/has_more']
		},
		filterType () {
			return this.$store.getters['tabs/filterType']
		},
		selected () {
			return this.$store.getters['tags/selected']
		},
		first_type_sction() {
			return this.$store.getters['tabs/filterType']
		},
		first_type_icon() {
			return this.type_icon(this.first_type_sction)
		},
		second() {
			const first = this.$store.getters['tabs/filterType']
			switch (first) {
				case 'inbox':
					return 'deferred'
				case 'deferred':
					return 'inbox'
				case 'done':
					return 'inbox'
			}
		},
		second_type_sction() {
			return this.second
		},
		second_type_icon() {
			return this.type_icon(this.second)
		},
		show_second () {
			return this.second_tabs.length != 0
		}
	},
	components: {
		Tab, 'virtual-list': virtualList
	},
	watch: {
		filterType: {
			immediate: false,
			handler(val) {
				document.getElementById('tab-scroll-area').scrollTo(0,0)
			},
		},
		selected: {
			immediate: false,
			handler(val) {
				document.getElementById('tab-scroll-area').scrollTo(0,0)
			},
		},
	},
	methods: {
		type_icon(type) {
			switch (type) {
				case 'inbox':
					return 'inbox'
				case 'done':
					return 'done'
				case 'deferred':
					return 'alarm'
				default:
					break;
			}
		},
		calc_remain() {
			this.remain = Math.ceil(window.innerHeight / 100)
		}
	},
	mounted() {
		this.calc_remain()
		window.addEventListener('resize', () => {
			this.calc_remain()
		})
	}
	  
}
</script>

<style lang="scss" scoped>
.tab-container {
	padding: 20px 20px 200px 20px;
	border: solid 0.4px #f7f7f7;
}

$duration: 0.5s !default;
.flip{ &-enter-active{
        opacity: 0;
        transform: translateX(50px);
        transition: {
            property       : transform, opacity;
            duration       : $duration;
            timing-function: cubic-bezier(0.77, 0, 0.175, 1);
            delay          : 0s;
        }
    }
    &-enter-to{
        opacity: 1;
        transform: translateX(0);
    }
    &-leave-active{
        opacity: 1;
        transform: translateX(0);
        transition: {
            property       : transform, opacity;
            duration       : $duration;
            timing-function: cubic-bezier(0.77, 0, 0.175, 1);
            delay          : 0s;
        }
    }
    &-leave-to{
        opacity: 0;
        transform: translateX(50px);
    }
    &-move{
        transition: {
            property       : transform;
            duration       : $duration;
            timing-function: cubic-bezier(0.77, 0, 0.175, 1);
            delay          : 0s;
        }
    }
}

.section-header {
	// background: #f0f0f1;
	background: #fff;
	text-align: left;
	padding: 2px 10px 0px 10px;
	border: solid 1px lightgray;
}
</style>
